import { closeAll, toggleDisabled, toggleLang, toggleNav, toggleSearch } from "./dom"

export function initHeader(): void {
  const nav = document.querySelector(".header__navigation")
  const langSwitcher = document.querySelector(".header__language-switcher")
  const search = document.querySelector(".header__search")
  const allToggles = document.querySelectorAll(".header--toggle")
  const navToggle = document.querySelector(".header__navigation--toggle")
  const langToggle = document.querySelector(".header__language-switcher--toggle")
  const searchToggle = document.querySelector(".header__search--toggle")
  const closeToggle = document.querySelector(".header__close--toggle")
  const allElements = document.querySelectorAll(".header--element, .header--toggle")
  const emailGlobalUnsub = document.querySelector('input[name="globalunsub"]') as HTMLInputElement | null

  if (langSwitcher && langToggle && closeToggle) {
    langToggle.addEventListener("click", () => toggleLang(allToggles, langSwitcher, langToggle, closeToggle))
  }
  if (nav && navToggle && closeToggle) {
    navToggle.addEventListener("click", () => toggleNav(allToggles, nav, navToggle, closeToggle))
  }
  if (search && searchToggle && closeToggle) {
    searchToggle.addEventListener("click", () => toggleSearch(allToggles, search, searchToggle, closeToggle))
  }
  if (closeToggle) {
    closeToggle.addEventListener("click", () => closeAll(allElements, closeToggle))
  }
  if (emailGlobalUnsub) {
    emailGlobalUnsub.addEventListener("change", () => toggleDisabled(emailGlobalUnsub))
  }
}
